// Duits (de-DE), remindersApp: zelfde vorm als remindersApp.nl.ts. Wat ontbreekt valt terug op
// het Nederlands (nooit een rauwe sleutel op het scherm).
export const appRemindersDe = {
    section: 'Erinnerungen',
    sectionHint: 'Ein extra Hinweis auf dem Tablet: Der Bildschirm ruft dein Kind beim Namen, mit einem großen Bild. Mit einer Abhakliste, was mit muss.',
    allDayHint: 'Erinnerungen funktionieren bei Terminen mit Uhrzeit.',
    add: 'Erinnerung',
    addTitle: 'Neue Erinnerung',
    editTitle: 'Erinnerung ändern',
    edit: 'Ändern',
    remove: 'Entfernen',
    removed: 'Erinnerung entfernt',
    confirmAdd: 'Erinnerung hinzufügen',
    confirmSave: 'Erinnerung aktualisieren',
    closeForm: 'Formular ohne diese Erinnerung schließen',
    max: 'Höchstens 5 Erinnerungen pro Termin.',
    when: 'Wann',
    customWhen: 'Eigene Zeit',
    customLabel: 'Minuten vorher',
    customHint: '1 bis 1440 Minuten (ein Tag).',
    offsetInvalid: 'Wähle 1 bis 1440 Minuten.',
    text: 'Text',
    textPlaceholder: 'Fertig machen fürs Training',
    textRequired: 'Gib einen kurzen Text ein.',
    textTooLong: 'Höchstens 60 Zeichen.',
    suggestions: 'Vorschläge',
    picto: 'Symbol',
    forWho: 'Für wen',
    everyone: 'Alle vom Termin',
    everyoneKids: 'Alle Kinder',
    whoRequired: 'Wähle, für wen diese Erinnerung ist.',
    prunedChanged: '{names} macht nicht mehr mit; Erinnerung „{title}“ wurde angepasst.',
    prunedChangedMany: '{names} machen nicht mehr mit; Erinnerung „{title}“ wurde angepasst.',
    prunedRemoved: '{names} macht nicht mehr mit; Erinnerung „{title}“ wurde entfernt.',
    prunedRemovedMany: '{names} machen nicht mehr mit; Erinnerung „{title}“ wurde entfernt.',
    prunedThisHint: 'Wählst du beim Speichern „Nur dieses Mal“, bleiben die Erinnerungen für die anderen Male einfach bestehen.',
    allDayDrop: 'Bei ganztägigen Terminen ruft das Tablet nicht: Diese Erinnerungen fallen beim Speichern weg.',
    and: 'und',
    speak: 'Vorlesen',
    speakHint: 'Das Tablet sagt den Namen und den Text laut.',
    sound: 'Ton',
    soundHint: 'Ein leises Glöckchen (nicht in den Ruhezeiten).',
    preview: 'So ruft das Tablet',
    previewOk: 'Okay',
    previewContext: '{title} um {time}',
    previewNoTitle: 'Termin',
    minutes: '{count} Min.',
    hours: '{count} Std.',
    hoursMinutes: '{hours} Std. {minutes} Min.',
    before: '{when} vorher',
    chip: '{when} vorher · {title}',
    chipLabel: 'Erinnerung {when} vorher: {title}',
    skipOnce: 'Nur dieses Mal nicht',
    skipOnceLabel: 'Erinnerung „{title}“ nur dieses Mal nicht',
    skipOnceDone: 'Diesmal ruft das Tablet nicht: {title}',
    skippedChip: 'Diesmal nicht',
    unskip: 'Doch rufen',
    unskipLabel: 'Erinnerung „{title}“ diesmal doch rufen',
    unskipDone: 'Diesmal ruft das Tablet wieder: {title}',
    suggestTraining: 'Fertig machen fürs Training',
    suggestSwim: 'Schwimmtasche packen',
    suggestBag: 'Tasche bereitstellen',
    suggestShoes: 'Schuhe und Jacke an',
    suggestGeneric: 'Fertig machen für {title}',
    suggestGenericEmpty: 'Fertig machen',
    taskTime: 'Uhrzeit',
    taskTimeHint: 'Darf leer bleiben.',
    taskAnnounce: 'Auf dem Board ansagen',
    taskAnnounceHint: 'Zu dieser Zeit klingelt das Tablet und sagt, wer was tun soll. Still in den Ruhezeiten und nachts.',
};
//# sourceMappingURL=remindersApp.de.js.map